import * as React from 'react';
import IDHelpers from '@/core/helpers/IDHelper';
import ReusableDate from '@/presentation/reusables/Date';
import IconRemote from '../../../../../assets/icons/IconRemote.svg';
import IconPresencial from '../../../../../assets/icons/icon-map-pin.svg';
import RemotoCancelado from '../../../../../assets/icons/events/RemotoCancelado.svg'; // '../../../../../../assets/icons/events/RemotoCancelado.svg';
import presencialCancelado from '../../../../../assets/icons/events/presencialCancelado.svg';
import {
  CardButton,
  CardHeader,
  CardTitle,
  CardText1,
  CardBody,
  BodyIcon,
  BodyContent,
  CardDays,
  CardRemote,
  CardClock
} from '../body/EventsBodyStyled';
import EventImage from '../eventImages';
import EventSchedule from '../eventSchedule';
import EventScheduleDays from '../eventScheduleDays';
import TagFeatured from '../TagFeatured';
import {
  CardCanceled,
  CardLabels
} from '../body/inscriptions/InscriptionsStyled';
import Tag from '@/presentation/reusables/Tag';
import { WaintingListStatus } from '../../constants';
import useExternalSettings from '@/presentation/hooks/useExternalSettings';

interface CardButtonEventProps {
  event: any;
  selectEvent: () => void;
  isSanctioned?: boolean;
}

export const getWaitingListStatus = (status: string) => {
  if (status === WaintingListStatus.IN_WAITING_LIST) {
    return { name: 'En espera', color: '#456271' };
  }
  if (status === WaintingListStatus.REGISTERED) {
    return { name: 'Inscrito', color: '#005C27' };
  }
  if (status === WaintingListStatus.ENABLED_TO_REGISTER) {
    return { name: 'Vacante disponible', color: '#0060AB' };
  }
  return { name: '', color: '' };
};

export const CardButtonEvent = ({
  event,
  selectEvent,
  isSanctioned
}: CardButtonEventProps) => {
  const { name, color } = getWaitingListStatus(event.statusWaitingList);
  const { eventType, eventSubtype, isSubscribed, statusWaitingList } = event;
  const { eventPenalties } = useExternalSettings(); // example { WORKSHOPS: [1, 2] };

  let applyPenaltie = false;

  if (!!eventPenalties && eventPenalties[eventType.name]) {
    applyPenaltie =
      !!isSanctioned && // when the current period is whitin sanctioned periods
      new Set(eventPenalties[eventType.name]).has(eventSubtype.id) && // is a restricted event type
      !isSubscribed && // Not subscribed
      !new Set([
        WaintingListStatus.IN_WAITING_LIST,
        WaintingListStatus.ENABLED_TO_REGISTER
      ]).has(statusWaitingList); // Status is not LE or VD
  }
  const isCanceled = event.isCanceled || applyPenaltie;
  if (applyPenaltie) return null;

  return (
    <CardButton
      data-testid="btnState-event-category"
      className={isCanceled === true ? 'eventoCancelado' : ''}
      key={IDHelpers.generateID()}
      onClick={() => {
        selectEvent();
      }}
      type="button"
    >
      <CardHeader>
        <CardTitle title={event.name}>
          {event.name}
          {/* <br />
          {eventType.name} - {eventSubtype.name} */}
        </CardTitle>
        <CardLabels>
          {isCanceled ? (
            <CardCanceled>
              {applyPenaltie ? 'Sancionado' : 'Cancelado'}
            </CardCanceled>
          ) : (
            <div style={{ gap: 4, display: 'flex' }}>
              {event.isToday && <CardText1>Hoy</CardText1>}
              {event.isFeatured && <TagFeatured isCard />}
              {event.statusWaitingList && (
                <Tag color={color} title={name} weight="400" />
              )}
              {event.isSubscribed && (
                <Tag color="#005C27" title="Inscrito" weight="400" />
              )}
            </div>
          )}
        </CardLabels>
      </CardHeader>
      <CardBody>
        <BodyIcon>
          <EventImage image={event.eventImage} />
        </BodyIcon>
        <BodyContent>
          <ReusableDate
            size={event.startDate === event.endDate ? 'medium' : 'small'}
            boldPrefix
            fontSize="12px"
            gap="4px"
            showPrefix={event.startDate !== event.endDate}
            startDate={event.startDate}
          />
          <CardDays>
            <EventScheduleDays
              isOnly={event.isOnly}
              isCard
              schedule={event.schedule}
            />
          </CardDays>
          <CardRemote>
            <CardClock>
              <EventSchedule
                isCanceled={isCanceled}
                isCard
                isOnly={event.isOnly}
                schedule={event.schedule}
              />
            </CardClock>
            {isCanceled && (
              <img
                style={{ width: '20px', height: '20px', filter: 'inherit' }}
                src={
                  event.modality === 'P' ? presencialCancelado : RemotoCancelado
                }
                alt="Iconmodality"
              />
            )}
            {isCanceled === false && (
              <img
                style={{ width: '20px', height: '20px' }}
                src={event.modality === 'P' ? IconPresencial : IconRemote}
                alt="Iconmodality"
              />
            )}
          </CardRemote>
        </BodyContent>
      </CardBody>
    </CardButton>
  );
};
